// extracted by mini-css-extract-plugin
export var blue = "_44-h";
export var brand = "_44-d";
export var darkGrey = "_44-g";
export var disabled = "_44-6";
export var disabledSubtle = "_44-7";
export var error = "_44-8";
export var green = "_44-i";
export var grey = "_44-f";
export var icon = "_44-0";
export var inherit = "_44-c";
export var lightGrey = "_44-e";
export var orange = "_44-k";
export var pink = "_44-m";
export var primary = "_44-1";
export var purple = "_44-n";
export var quaternary = "_44-4";
export var quinary = "_44-5";
export var red = "_44-l";
export var secondary = "_44-2";
export var success = "_44-b";
export var tertiary = "_44-3";
export var warning = "_44-9";
export var warningSecondary = "_44-a";
export var white = "_44-o";
export var yellow = "_44-j";